var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.44444 2 2 6.44444 2 12C2 17.5556 6.44444 22 12 22C17.5556 22 22 17.5556 22 12C22 6.55556 17.5556 2 12 2ZM12 20.7778C7.22222 20.7778 3.22222 16.8889 3.22222 12.1111V12C3.22222 7.22222 7.11111 3.22222 11.8889 3.22222H12C16.7778 3.22222 20.7778 7.11111 20.7778 11.8889V12C20.7778 16.7778 16.7778 20.7778 12 20.7778ZM7.66667 8.44444H8.88889V15.5556H7.66667V8.44444ZM16.3333 15.6667V8.33333L10 12L16.3333 15.6667ZM15.1111 13.5556L12.5556 12L15.1111 10.5556V13.5556Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.f32d8df6036aa0476ca518f3c682a15a.svg";
export { ForwardRef as ReactComponent };